import React from 'react'

function CollapsibleArrowDown(props) {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" className={props.className} width="12" height="9" viewBox="0 0 12 9">
        <defs>
            <clipPath>
            <rect width="12" height="9"/>
            </clipPath>
        </defs>
        <g dataname="Arrow 1" clipPath="url(#clip-Arrow_1)">
            <rect width="12" height="9" fill="transparent"/>
            <path dataname="Path 6 Copy" d="M0,10,5,5,0,0" transform="translate(11 2) rotate(90)" fill="none" stroke={props.color||"#808080"} strokeLinecap="round" 
            strokeLinejoin="round" strokeMiterlimit="10" strokeWidth="1"/>
        </g>
        </svg>
    )
}

export default CollapsibleArrowDown;
